export const PAGE_LINKS = {
  home: '/',
  courseware: '/',
  template: '/template',
  login: '/login',
}

export enum PPT_TYPE_ENUM {
  courseware = 'courseware',
  template = 'template',
}

// 错误码
export enum ErrorCodeEnum {
  /**
   * 权限不足
   */
  NotAuthorized = 10031,
  /**
   * Token 过期、无效
   */
  TokenInvalid = 10032,
  /**
   * 用户错误
   */
  UserError = 10033,
  /**
   * 缺少 token
   */
  MissingToken = 10034,
}

export enum PPT_ACTION_ENUM {
  /**
   * 编辑
   */
  edit = 'edit',
  /**
   * 预览
   */
  preview = 'preview',
  /**
   * 播放
   */
  play = 'play',
}

export enum FILE_TYPE {
  /**
   * 封面
   */
  CoverImage = 'cover_image',
  /**
   * 媒体文件
   */
  MediumInfo = 'medium_info',
  /**
   * 附件
   */
  OriginalFile = 'original_file',
  /**
   * 教案
   */
  TeachPlan = 'teaching_plan',
}
